<template>
	<v-container>
		<v-row>
			<v-col cols="12">
				<div class="code-container">
					<h1 class="code">
						{{ error.code }}
					</h1>

					<div class="d-flex flex-column">
						<strong>
							{{ error.title }}
						</strong>
						<small>
							{{ error.text }}
						</small>
					</div>
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: "Error",

	data() {
		return {
			errors: [
				{ code: 400, title: 'BAD REQUEST', text: 'No se puede procesar la petición.' },
				{ code: 401, title: 'UNAUTHORIZED', text: 'La solicitud no se ha aplicado porque carece de credenciales de autenticación válidas para el recurso de destino.' },
				{ code: 403, title: 'FORBIDDEN', text: 'Acceso denegado.' },
				{ code: 404, title: 'NOT FOUND', text: 'Recurso no encontrado.' },
			],

			error: {
				code: null,
				text: null,
			}
		};
	},

	created(){
		try{
			let error = this.errors.find(error => error.code == this.$route.params.code)

			if (error) {
				this.error = error
			}else{
				this.error = {
					code: 'Woops!',
					title: 'Error',
					text: 'Lo sentimos algo salio mal.',
				}
			}
		}catch(error){
		}
	}
};
</script>

<style lang="css" scoped>
.code-container {
	display: flex;
	align-items: center;
	min-height: 80vh;
	justify-content: center;
}
.code {
	position: relative;
	margin-right: 25px;
}
.code::after {
	content: "";
	margin-left: 10px;
	position: absolute;
	height: 100%;
	width: 2px;
	background-color: #000;
}
</style>
